import {Component, HostBinding, Input} from '@angular/core';

const componentBaseName = 'icon-text';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-icon-text',
  templateUrl: './icon-text.component.html',
})
export class IconTextComponent {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() label: string;
  @Input() value: string;

  constructor() { }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-base/components/icon-text/icon-text.component.ts